import { c as _c } from "react/compiler-runtime";
import { getCountryFromCode } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import { useTranslation } from 'react-i18next';
import HeaderTitle from '../header-title';
type DesktopHeaderProps = {
  docName?: string;
  sideName?: string;
  country?: Iso3166TwoDigitCountryCode;
  isSelfie?: boolean;
};
const DesktopHeader = t0 => {
  const $ = _c(11);
  const {
    docName,
    sideName,
    country,
    isSelfie
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.desktop-header"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let subtitle;
  let title;
  if ($[1] !== country || $[2] !== docName || $[3] !== isSelfie || $[4] !== sideName || $[5] !== t) {
    const countryName = getCountryFromCode(country)?.label;
    title = `${docName}`;
    if (!docName || isSelfie) {
      title = `${sideName}`;
    } else {
      if (docName && sideName) {
        title = `${docName} · ${sideName}`;
      }
    }
    if (!isSelfie && countryName) {
      subtitle = t(_temp, {
        country: countryName
      });
    }
    $[1] = country;
    $[2] = docName;
    $[3] = isSelfie;
    $[4] = sideName;
    $[5] = t;
    $[6] = subtitle;
    $[7] = title;
  } else {
    subtitle = $[6];
    title = $[7];
  }
  let t2;
  if ($[8] !== subtitle || $[9] !== title) {
    t2 = <HeaderTitle title={title} subtitle={subtitle} />;
    $[8] = subtitle;
    $[9] = title;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default DesktopHeader;
function _temp($) {
  return $.subtitle;
}